import truncate from 'lodash.truncate'

export const truncateBreadcrumbText = (breadcrumbText: string) => {
  return truncate(breadcrumbText, {
    length: 32 // arbitrary length :shrug:
  })
}
